import { createContext } from "react";
import { intialState } from "./provider";
// import { getCookie } from "cookies-next";
// Create the Cart context
export const CheckoutContext = createContext();

function checknationalAddressIdMandatory(address, items) {
  const [regionId, nationalAddressId, isItemsRequiredNA] = [
    address?.region_id,
    address?.custom_attributes?.national_address_id,
    items?.some(p => p?.extension_attributes?.national_address_id_mandatory || false)
  ]
  let status = regionId == '1101' 
  ? false 
  : isItemsRequiredNA 
  ? nationalAddressId 
  ? false 
  : true 
  : false;
  console.log('checknationalAddressIdMandatory', {regionId, status, nationalAddressId, isItemsRequiredNA});
  return status
}
// checkout reducer function
export const cartReducer = (state, action) => {
  switch (action.type) {
    case "GET_BILLADDRESS":
      case "EDIT_BILLING_ADDRESS":
      console.log(
        "checknationalAddressIdMandatorychecknationalAddressIdMandatory ===========>", action?.payload
      );
      const address = action?.payload;
      const na = address?.national_address
      if(na){
        address.custom_attributes = address?.custom_attributes || {}
        address.custom_attributes.national_address_id = na;
        delete address.national_address;
      }
      return {
        ...state,
        billing_address: address,
        isNAIDRequired: checknationalAddressIdMandatory(address, state?.cart?.items)
      };
    case "GET_ALL":
      // const regId = state?.billing_address?.region_id || getCookie('region_id');
      // const items = action?.payload?.items?.some(p => p?.extension_attributes?.national_address_id_mandatory || false);
      // const st = regId == '1101' ? false : items ? true : false;
      // console.log('GET_ALL checknationalAddressIdMandatory', {regId, st, items});
      return {
        ...state,
        cart: action?.payload,
        items: action?.payload?.items,
        // ...(state?.cart?.items?.length && regId != 1101
        //   ? { isNAIDRequired: false }
        //   : { isNAIDRequired: st }),
      };
    case "GET_SHIPPING_METHODS":
      return {
        ...state,
        shipping_methods: action?.payload,
      };
    case 'NAID_REQUIRED':
      return {
        ...state,
        isNAIDRequired: action?.payload,
      };
    case "PAYMENTS":
      const hideInstallments = (state?.cart?.totals?.items || [])?.some(
        (item) => item?.extension_attributes?.is_pre_order === true
      );
      const disabledPaymentMethods = [
        // "bs_checkout",
        // "madfu_checkout",
        // "mispaymethod",
        // "tabby_installments",
        // "tamara_pay_by_instalments_4",
        // "tamara_pay_by_instalments_6",
      ];
      const filteredPayments = Object.values(action?.payload || {}).filter(
        (payment) => payment.is_available
      );
      const filteredPayments2 = filteredPayments.filter(
        (payment) => !disabledPaymentMethods.includes(payment.code)
      );
      return {
        ...state,
        payments: hideInstallments ? filteredPayments2 : filteredPayments,
      };
    case "GET_REGIONS":
      return {
        ...state,
        shipping_methods: action?.payload,
      };
    case "GET_TEL":
      return {
        ...state,
        tel: action?.payload,
      };
    case "VERIFY_MOBILE":
      const { number: mobile, status } = action.payload;
         return {
        ...state,
        mobiles: { ...state.mobiles, [mobile]: status },
      };
    case "RESET_CHECKOUT":
      return intialState
    default:
      return state;
  }
};